import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import ElementUI from 'element-ui';
import request from './request/request';
import filters from './assets/js/filters';
import directives from './assets/js/directives';
import Public from './assets/js/public.js';
import 'element-ui/lib/theme-chalk/index.css';
import VueBus from 'vue-bus';
import VueQuillEditor from 'vue-quill-editor'; // 富文本编辑器

// 引入echarts
import echarts from 'echarts';

Vue.config.productionTip = false;
Vue.prototype.request = request;
Vue.prototype.httpGet = request.get;
Vue.prototype.$Public = Public;
Vue.prototype.httpPost = request.post;
Vue.prototype.httpPut = request.put;
Vue.prototype.httpDelete = request.delete;
Vue.prototype.httpUploadImg = request.upPic;
Vue.prototype.httpUploadFile = request.upFile;
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
Vue.use(VueBus);
Vue.use(VueQuillEditor);

router.beforeEach((to, from, next) => {
    const token = store.getters.token;
    if (token) {
        next();
    } else {
        // 这就是跳出循环的关键(起码执行两遍)
        if (to.path === '/login') {
            next();
        } else {
            // 没有token跳路由，统统送去login
            next('/login');
        }
    }
});

// 注册全局过滤器
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));

// 注册全局指令
Object.keys(directives).forEach(key => Vue.directive(key, directives[key]));

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
